import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import { addGraphicLayer } from '../../utils/graghics/index';
export function initSketchViewModel(sketchModel) {
    debugger;
    const options = {
        point: {
            className: "esri-widget--button esri-icon-map-pin geometry-button",
            id: "point-geometry-button",
            value: "point",
            title: "Filter by point"
        },
        polygon: {
            className: "esri-widget--button esri-icon-polygon geometry-button",
            id: "polygon-geometry-button",
            value: "polygon",
            title: "Filter by polygon"
        },
        polyline: {
            className: "esri-widget--button esri-icon-polyline geometry-button",
            id: "line-geometry-button",
            value: "polyline",
            title: "Filter by polyline"
        }
    };
    // const drawingContainer = document.querySelector(sketchModel.mapContainerId);
    let el_btn_point = document.querySelector('#point-geometry-button');
    if (!el_btn_point) {
        el_btn_point = createElement('button', options.point);
    }
    let el_btn_polyline = document.querySelector('#line-geometry-button');
    if (!el_btn_polyline) {
        el_btn_polyline = createElement('button', options.polyline);
    }
    let el_btn_polygon = document.querySelector('#polygon-geometry-button');
    if (!el_btn_polygon) {
        el_btn_polygon = createElement('button', options.polygon);
    }
    const sketchLayer = addGraphicLayer('sketch', sketchModel.mapView);
    el_btn_point.addEventListener("click", function (e) {
        e.preventDefault();
        geometryButtonsClickHandler('point');
    });
    el_btn_polygon.addEventListener("click", function (e) {
        e.preventDefault();
        geometryButtonsClickHandler('polygon');
    });
    el_btn_polyline.addEventListener("click", function (e) {
        e.preventDefault();
        geometryButtonsClickHandler('polyline');
    });
    const sketchViewModel = new SketchViewModel({
        view: sketchModel.mapView,
        layer: sketchLayer,
        snappingOptions: {
            enabled: sketchModel.snappingOptions ? true : false,
        },
        pointSymbol: sketchModel.pointSymbol,
        polygonSymbol: sketchModel.polygonSymbol,
        polylineSymbol: sketchModel.polylineSymbol,
        //updateOnGraphicClick: sketchModel.updateOnGraphicClick
    });
    function geometryButtonsClickHandler(geometryType) {
        sketchModel.clear === true ? sketchLayer.removeAll() : undefined;
        sketchViewModel.create(geometryType);
    }
    sketchViewModel.on("create", function (event) {
        if (event.state === "complete") {
            sketchModel.callbackWhenDone(event);
        }
    });
    if (sketchModel.availableTools?.length > 0) {
        sketchModel.availableTools?.includes('point') ?
            sketchModel.mapView.ui.add(el_btn_point, sketchModel.controlPosition) : undefined;
        sketchModel.availableTools?.includes('polyline') ?
            sketchModel.mapView.ui.add(el_btn_polyline, sketchModel.controlPosition) : undefined;
        sketchModel.availableTools?.includes('polygon') ?
            sketchModel.mapView.ui.add(el_btn_polygon, sketchModel.controlPosition) : undefined;
    }
    else {
        sketchModel.mapView.ui.add(el_btn_point, sketchModel.controlPosition);
        sketchModel.mapView.ui.add(el_btn_polyline, sketchModel.controlPosition);
        sketchModel.mapView.ui.add(el_btn_polygon, sketchModel.controlPosition);
    }
}
function createElement(elType, options) {
    let el = document.createElement(elType);
    el.className = options.className;
    el.id = options.id;
    el.value = options.value;
    el.title = options.title;
    return el;
}
